document.addEventListener('DOMContentLoaded',()=>{
 const motion=matchMedia('(prefers-reduced-motion: reduce)');
 const root=document.documentElement;
 const controls=document.querySelectorAll('[data-pantry-motion]');
 const sync=()=>{
  const on=root.dataset.reactions!=='off'&&!motion.matches;
  controls.forEach(button=>{
   button.setAttribute('aria-pressed',String(on));
   button.textContent=on?button.dataset.on:button.dataset.off;
   button.setAttribute('aria-label',motion.matches?button.dataset.reduced:on?button.dataset.disable:button.dataset.enable);
   button.title=motion.matches?button.dataset.reduced:on?button.dataset.disable:button.dataset.enable;
   button.disabled=motion.matches;
  });
  document.dispatchEvent(new Event('pantry:motion-change'));
 };
 controls.forEach(button=>button.addEventListener('click',()=>{
  if(motion.matches)return;
  const next=root.dataset.reactions==='off'?'on':'off';
  root.dataset.reactions=next;
  try{localStorage.setItem('pantry-reactions',next);}catch(e){}
  sync();
 }));
 motion.addEventListener('change',()=>{
  try{root.dataset.reactions=localStorage.getItem('pantry-reactions')||'on';}catch(e){root.dataset.reactions='on';}
  sync();
 });
 sync();
});

document.addEventListener('DOMContentLoaded',()=>{const b=document.querySelector('.menu-toggle'),n=document.querySelector('#mobile-nav');if(b&&n)b.addEventListener('click',()=>{const expanded=b.getAttribute('aria-expanded')==='true';b.setAttribute('aria-expanded',String(!expanded));n.hidden=expanded;});});
document.addEventListener('DOMContentLoaded',()=>{
 const toggle=document.querySelector('.alchemist-search-toggle'),panel=document.querySelector('#alchemist-inline-search'),input=document.querySelector('#alchemist-search-input'),close=document.querySelector('.alchemist-search-close'),results=document.querySelector('#alchemist-search-suggestions'),source=document.querySelector('#alchemist-search-index');
 if(!toggle||!panel||!input||!results||!source)return;
 let items=[],timer,opener=toggle;
 const normal=s=>String(s||'').normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[’']/g,'');
 try{const seen=new Set();items=JSON.parse(source.textContent).filter(Boolean).filter(item=>{const u=new URL(item.url,location.origin);if(u.origin!==location.origin)return false;const key=u.pathname.replace(/\/$/,'');if(seen.has(key))return false;seen.add(key);item.url=u.pathname+u.search;item.text=normal(item.title+' '+item.terms);return true;});}catch(e){items=null;}
 input.removeAttribute('aria-autocomplete');
 const message=text=>{results.replaceChildren();const p=document.createElement('p');p.setAttribute('role','status');p.textContent=text;results.append(p);};
 const render=()=>{
  clearTimeout(timer);results.removeAttribute('aria-busy');
  const q=normal(input.value.trim());
  if(!q){message('Enter an ingredient, scientific name, chapter or pantry topic.');return;}
  if(!items){message('Search is temporarily unavailable. Please refresh and try again.');return;}
  const words=q.split(/\s+/),matches=items.filter(item=>words.every(w=>item.text.includes(w))).sort((a,b)=>Number(normal(b.title)===q)-Number(normal(a.title)===q)||Number(normal(b.title).startsWith(q))-Number(normal(a.title).startsWith(q))||a.title.localeCompare(b.title));
  message(matches.length?matches.length+' matching '+(matches.length===1?'result':'results')+'.':'No matches. Try a common name, scientific name or chapter.');
  if(!matches.length)return;
  const list=document.createElement('ul');
  matches.forEach(item=>{const li=document.createElement('li'),a=document.createElement('a'),small=document.createElement('small');a.href=item.url;a.textContent=item.title;small.textContent=' · '+item.kind;li.append(a,small);list.append(li);});results.append(list);
 };
 const shut=()=>{clearTimeout(timer);panel.hidden=true;toggle.setAttribute('aria-expanded','false');opener?.focus();};
 const open=from=>{opener=from||toggle;panel.hidden=false;toggle.setAttribute('aria-expanded','true');render();panel.scrollIntoView({block:'nearest'});input.focus({preventScroll:true});};
 toggle.addEventListener('click',()=>panel.hidden?open(toggle):shut());
 close?.addEventListener('click',shut);
 document.addEventListener('click',e=>{const a=e.target.closest('a');if(a&&new URL(a.href,location.origin).pathname==='/search'){e.preventDefault();open(a);}});
 document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!panel.hidden){e.preventDefault();shut();}});
 input.form.addEventListener('submit',e=>{e.preventDefault();render();});
 input.addEventListener('input',()=>{clearTimeout(timer);message('Searching the pantry…');results.setAttribute('aria-busy','true');timer=setTimeout(render,160);});
 input.addEventListener('keydown',e=>{if(e.key==='ArrowDown'||e.key==='ArrowUp'){e.preventDefault();render();const links=results.querySelectorAll('a');(e.key==='ArrowDown'?links[0]:links[links.length-1])?.focus();}});
 results.addEventListener('keydown',e=>{const links=Array.from(results.querySelectorAll('a')),i=links.indexOf(document.activeElement);if(i<0)return;if(e.key==='ArrowDown'){e.preventDefault();links[(i+1)%links.length].focus();}if(e.key==='ArrowUp'){e.preventDefault();if(i===0)input.focus();else links[i-1].focus();}if(e.key==='Home'){e.preventDefault();links[0].focus();}if(e.key==='End'){e.preventDefault();links[links.length-1].focus();}});
 if(location.pathname==='/search'){input.value=new URLSearchParams(location.search).get('q')||'';open(toggle);}
});
/* v2.8: seamless alchemical vapour, full viewport. Green, blue and crimson wisps. */
(function () {
 const canvas=document.getElementById('alchemist-mystic-smoke');
 if(!canvas)return;
 const ctx=canvas.getContext('2d',{alpha:true});
 if(!ctx)return;
 const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
 const effectsOff=()=>reduced.matches||document.documentElement.dataset.reactions==='off';
 const palette=[[138,142,143],[153,151,148],[118,124,129],[164,160,153],[128,134,138]];
 let width=0,height=0,dpr=1,particles=[],raf=0,last=0;
 const rand=(a,b)=>a+Math.random()*(b-a);
 function particle(initial){
  const color=palette[Math.floor(rand(0,palette.length))];
  return {x:rand(-.06,1.06)*width,y:initial?rand(height*.2,height*1.2):height+rand(20,height*.3),
    radius:rand(115,245)*Math.max(.7,Math.min(1.4,width/1000)),
    vx:rand(-.15,.15),vy:rand(.38,.85),age:rand(0,1000),phase:rand(0,6.28),
    color,opacity:rand(.37,.60)};
 }
 function resize(){
  width=window.innerWidth;height=window.innerHeight;
  dpr=Math.min(window.devicePixelRatio||1,1.5);
  canvas.width=Math.round(width*dpr);canvas.height=Math.round(height*dpr);
  ctx.setTransform(dpr,0,0,dpr,0,0);
  particles=Array.from({length:width<650?26:43},()=>particle(true));
 }
 function draw(now){
  if(effectsOff()){ctx.clearRect(0,0,width,height);raf=0;return;}
  if(document.hidden){raf=requestAnimationFrame(draw);return;}
  const dt=Math.min(40,now-(last||now));last=now;
  ctx.clearRect(0,0,width,height);
  ctx.globalCompositeOperation='screen';
  for(let i=0;i<particles.length;i++){
   const p=particles[i];
   if(!reduced.matches){
    p.age+=dt*.001;
    p.y-=p.vy*dt*.048;
    p.x+=(p.vx+Math.sin(p.age*.75+p.phase)*.22)*dt*.05;
    if(p.y+p.radius*1.6<0||p.x < -width*.35||p.x>width*1.35)particles[i]=particle(false);
   }
   const r=p.radius*(.95+.12*Math.sin(p.age*.4+p.phase));
   const grad=ctx.createRadialGradient(p.x,p.y,0,p.x,p.y,r);
   const [red,green,blue]=p.color;
   const fade=Math.max(.08,Math.min(1,(height-p.y)/Math.max(120,height*.22)+.7));
   const alpha=p.opacity*fade;
   grad.addColorStop(0,`rgba(${red},${green},${blue},${alpha})`);
   grad.addColorStop(.3,`rgba(${red},${green},${blue},${alpha*.74})`);
   grad.addColorStop(.66,`rgba(${red},${green},${blue},${alpha*.28})`);
   grad.addColorStop(1,`rgba(${red},${green},${blue},0)`);
   ctx.fillStyle=grad;
   ctx.beginPath();ctx.ellipse(p.x,p.y,r*.77,r,Math.sin(p.phase+p.age*.2)*.24,0,Math.PI*2);ctx.fill();
  }
  ctx.globalCompositeOperation='source-over';
  if(!reduced.matches)raf=requestAnimationFrame(draw);
 }
 window.addEventListener('resize',resize,{passive:true});window.addEventListener('orientationchange',resize,{passive:true});
 const syncSmoke=()=>{cancelAnimationFrame(raf);last=0;draw(performance.now());};
 reduced.addEventListener?.('change',syncSmoke);
 document.addEventListener('pantry:motion-change',syncSmoke);
 resize();raf=requestAnimationFrame(draw);
})();

document.addEventListener('DOMContentLoaded',()=>{
 const path=location.pathname.replace(/\/+$/,'')||'/';
 const legalPages=new Set(['/pages/terms-conditions','/pages/privacy-policy','/pages/shipping-delivery','/pages/returns-refunds','/pages/cookies-preferences','/pages/ingredients-allergens','/pages/business-details']);
 if(path.startsWith('/policies/')||legalPages.has(path)||!('IntersectionObserver' in window))return;
 const motion=matchMedia('(prefers-reduced-motion: reduce)');
 const effectsOff=()=>motion.matches||document.documentElement.dataset.reactions==='off';
 const revealSpeed=1.5;
 const active=new Map();
 const finish=el=>{
  const state=active.get(el);
  if(state){
   clearTimeout(state.timer);
   el.querySelectorAll('.pantry-reaction-word').forEach(word=>word.replaceWith(document.createTextNode(word.textContent)));
   if(state.labelled){if(state.label===null)el.removeAttribute('aria-label');else el.setAttribute('aria-label',state.label);}
   active.delete(el);
  }
  el.classList.remove('pantry-conjure-wait','pantry-conjure-show');
  el.classList.add('pantry-reaction-done');
 };
 const show=(el,chainDelay=0)=>{
  el.classList.remove('pantry-conjure-wait');
  if(effectsOff()){finish(el);return;}
  const lettering=el.matches('h1,h2,h3,h4,.ornament,.hero-content > .eyebrow,.hero-tagline');
  const labelled=el.matches('h1,h2,h3,h4,a,button');
  const label=el.getAttribute('aria-label');
  if(labelled)el.setAttribute('aria-label',label||el.innerText.replace(/\s+/g,' ').trim());
  const base=chainDelay;
  el.style.setProperty('--reaction-base',base+'s');
  const walker=document.createTreeWalker(el,NodeFilter.SHOW_TEXT,{
   acceptNode:node=>node.textContent.trim()&&!node.parentElement.closest('script,style,svg,.pantry-reaction-word')?NodeFilter.FILTER_ACCEPT:NodeFilter.FILTER_REJECT
  });
  const nodes=[];while(walker.nextNode())nodes.push(walker.currentNode);
  let index=0;
  const configure=(unit,i)=>{
   unit.classList.add('pantry-reaction-unit');
   unit.style.setProperty('--reaction-delay',(base+i*(lettering?.065:.11)/revealSpeed).toFixed(3)+'s');
   unit.style.setProperty('--reaction-x',((i*7%13)-6)+'px');
   unit.style.setProperty('--reaction-y',((i%3===0?-1:1)*(8+i*3%13))+'px');
   unit.style.setProperty('--reaction-turn',((i*11%17)-8)+'deg');
  };
  nodes.forEach(node=>{
   const fragment=document.createDocumentFragment();
   node.textContent.split(/(\s+)/).forEach(token=>{
    if(!token)return;
    if(/^\s+$/.test(token)){fragment.append(document.createTextNode(token));return;}
    const word=document.createElement('span');word.className='pantry-reaction-word';
    if(labelled)word.setAttribute('aria-hidden','true');
    if(lettering){
     Array.from(token).forEach(char=>{const glyph=document.createElement('span');glyph.className='pantry-reaction-glyph';glyph.textContent=char;configure(glyph,index++);word.append(glyph);});
    }else{word.textContent=token;configure(word,index++);}
    fragment.append(word);
   });
   node.replaceWith(fragment);
  });
  el.classList.add('pantry-conjure-show');
  active.set(el,{label,labelled,timer:setTimeout(()=>finish(el),(base+Math.max(0,index-1)*(lettering?.065:.11)/revealSpeed+2.1/revealSpeed)*1000)});
 };
 const clocks=new WeakMap();
 const observer=new IntersectionObserver(entries=>{
  const now=performance.now()/1000;
  entries.filter(entry=>entry.isIntersecting).sort((a,b)=>{
   const x=a.target.getBoundingClientRect(),y=b.target.getBoundingClientRect();
   return Math.abs(x.top-y.top)<24?x.left-y.left:x.top-y.top;
  }).forEach(entry=>{
   const el=entry.target;
   observer.unobserve(el);
   const group=el.closest('.product-card,.product-information,.g-card,.g-index-leaf,.g-note,.g-feature,.hero-content,.formula-intro,.story-copy,.values,section,header,footer')||el.parentElement;
   const lettering=el.matches('h1,h2,h3,h4,.ornament,.hero-content > .eyebrow,.hero-tagline');
   const count=lettering?Array.from(el.textContent.replace(/\s/g,'')).length:el.textContent.trim().split(/\s+/).length;
   const start=Math.max(now+.06/revealSpeed,clocks.get(group)||0);
   clocks.set(group,start+Math.max(.2/revealSpeed,(count-1)*(lettering?.065:.11)/revealSpeed)+.24/revealSpeed);
   show(el,start-now);
  });
 },{threshold:.08,rootMargin:'0px 0px -12px 0px'});
 const selector='header .desktop-nav a,header .mobile-nav a,header .music-label,main h1,main h2,main h3,main h4,main p,main a,main label,main button,main li,main dt,main dd,main .ornament,main .product-card > img,main .product-main-image,footer h2,footer p,footer a,footer button,footer .footer-bottom > span';
 const initialise=root=>{
  if(effectsOff())return;
  const candidates=[...(root.matches?.(selector)?[root]:[]),...root.querySelectorAll(selector)];
  candidates.forEach(el=>{
   if(el.closest('[hidden],details:not([open]),.alchemist-ledger,.pantry-reaction-word,[data-no-reaction]')||el.classList.contains('pantry-reaction-target')||el.matches('.apprentice-feedback'))return;
   if(el.matches('a')&&(el.closest('p,li,dd,.footer-bottom')||el.querySelector('h1,h2,h3,h4,p,img,svg')))return;
   if(el.matches('li,dd')&&el.querySelector('p,h1,h2,h3,h4,li,dd'))return;
   if(el.closest('form')&&!el.matches('label'))return;
   if(el.matches('img'))el.classList.add('pantry-reaction-image');
   el.classList.add('pantry-reaction-target','pantry-conjure-wait');observer.observe(el);
  });
 };
 initialise(document);
 const updates=new MutationObserver(records=>{
  if(effectsOff())return;
  records.forEach(record=>{
   if(record.target.closest?.('.pantry-reaction-target'))return;
   record.addedNodes.forEach(node=>{if(node.nodeType===1)initialise(node);});
  });
 });
 updates.observe(document.querySelector('main'),{childList:true,subtree:true});
 document.addEventListener('toggle',event=>{if(event.target.matches('details[open]'))initialise(event.target);},true);
 document.addEventListener('focusin',event=>{
  const targets=[event.target.closest('.pantry-reaction-target'),...event.target.querySelectorAll('.pantry-reaction-target')].filter(Boolean);
  targets.forEach(el=>{observer.unobserve(el);finish(el);});
 });
 const syncReactions=()=>{
  if(effectsOff()){
   observer.disconnect();
   document.querySelectorAll('.pantry-reaction-target').forEach(el=>{finish(el);el.classList.remove('pantry-reaction-target');});
  }else initialise(document);
 };
 motion.addEventListener('change',syncReactions);
 document.addEventListener('pantry:motion-change',syncReactions);
});
document.addEventListener('DOMContentLoaded',()=>{
 const key='pantry-guild-signup-pending';
 const permitted=()=>window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()===true;
 const forget=()=>{try{sessionStorage.removeItem(key);}catch(e){}};
 window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.2'}],()=>{});
 document.querySelectorAll('form[id="apprentice-guild-signup"]').forEach(form=>{
  form.addEventListener('submit',()=>{
   if(!form.checkValidity()||form.querySelector('[data-guild-honeypot]')?.value.trim()||!permitted()){forget();return;}
   const location=form.closest('[data-guild-location]')?.dataset.guildLocation||'guild_page';
   try{sessionStorage.setItem(key,JSON.stringify({created:Date.now(),location}));}catch(e){}
  },true);
 });
 const success=document.querySelector('[data-guild-success]');
 if(!success)return;
 let pending;
 try{pending=JSON.parse(sessionStorage.getItem(key)||'null');}catch(e){}
 forget();
 if(!pending||Date.now()-pending.created>1800000||Date.now()<pending.created)return;
 const send=()=>{
  if(!permitted())return;
  const location=['homepage','guild_page'].includes(pending.location)?pending.location:'guild_page';
  const payload={form_id:'apprentice-guild-signup',form_location:location};
  if(window.PantryAnalytics){
   success.dataset.guildGa4State=window.PantryAnalytics.trackGuildSignup(payload)?'queued':'consent-denied';
  }
  const publish=window.Shopify?.analytics?.publish;
  if(typeof publish!=='function'){success.dataset.guildEventState='unavailable';return;}
  try{
   Promise.resolve(publish('pantry:apprentice_guild_signup',payload)).then(result=>{
    success.dataset.guildEventState=result===false?'unavailable':'published';
   }).catch(()=>{success.dataset.guildEventState='unavailable';});
  }catch(e){success.dataset.guildEventState='unavailable';}
 };
 if(window.PantryAnalytics?.ready)window.PantryAnalytics.ready.then(send);else send();
});

